
import { motion } from 'framer-motion';

const ServicesList = () => {
  const digitalServices = [
    {
      title: 'Website Design & Development',
      description: 'Custom websites built on Squarespace and Webflow that combine stunning design with powerful functionality.',
      icon: 'ri-layout-line',
    },
    {
      title: 'Social Media Management',
      description: 'Strategic content planning, community engagement, and performance optimization across all major platforms.',
      icon: 'ri-share-line',
    },
    {
      title: 'Email Marketing',
      description: 'Targeted campaigns, automated funnels, and nurture sequences that convert prospects into loyal customers.',
      icon: 'ri-mail-send-line',
    },
    {
      title: 'SEO Strategy & Optimization',
      description: 'Data-driven SEO strategies that improve visibility, drive organic traffic, and increase conversions.',
      icon: 'ri-search-line',
    },
    {
      title: 'Google Analytics Setup & Reporting',
      description: 'Comprehensive analytics implementation, custom dashboards, and actionable insights for informed decision-making.',
      icon: 'ri-line-chart-line',
    },
  ];

  const consultingServices = [
    {
      title: 'Digital Consulting & Strategy',
      description: 'Strategic guidance for digital transformation initiatives, technology adoption, and organizational change.',
      icon: 'ri-lightbulb-line',
    },
    {
      title: 'PMO & Program Management',
      description: 'Enterprise-level program management office setup, governance frameworks, and delivery excellence.',
      icon: 'ri-organization-chart',
    },
    {
      title: 'ISO / Process Optimization & SOPs',
      description: 'Process improvement, ISO compliance preparation, and comprehensive standard operating procedure development.',
      icon: 'ri-file-list-3-line',
    },
    {
      title: 'Smartsheet, Jira & Confluence Setup',
      description: 'Expert configuration and optimization of project management tools for maximum team productivity.',
      icon: 'ri-tools-line',
    },
    {
      title: 'Audit Prep & Operational Readiness',
      description: 'Comprehensive audit preparation, compliance verification, and operational readiness assessments.',
      icon: 'ri-shield-check-line',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Digital & Growth Services */}
        <div className="mb-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-12"
          >
            <h2 className="font-playfair text-4xl lg:text-5xl font-semibold text-charcoal mb-4">
              Digital & Growth Services
            </h2>
            <p className="font-inter text-lg text-charcoal/60 max-w-3xl">
              Elevate your digital presence with strategic services designed to drive growth, engagement, and measurable results.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {digitalServices.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -8 }}
                className="bg-warm-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-warm-gold/20 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-warm-gold`}></i>
                </div>
                <h3 className="font-inter text-xl font-bold text-charcoal mb-3">
                  {service.title}
                </h3>
                <p className="font-inter text-base text-charcoal/70 leading-relaxed">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Consulting & PMO Services */}
        <div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-12"
          >
            <h2 className="font-playfair text-4xl lg:text-5xl font-semibold text-charcoal mb-4">
              Consulting & PMO Services
            </h2>
            <p className="font-inter text-lg text-charcoal/60 max-w-3xl">
              Strategic consulting and program management expertise to transform operations and deliver enterprise-grade results.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {consultingServices.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -8 }}
                className="bg-muted-taupe/30 rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="w-14 h-14 bg-warm-gold/20 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-warm-gold`}></i>
                </div>
                <h3 className="font-inter text-xl font-bold text-charcoal mb-3">
                  {service.title}
                </h3>
                <p className="font-inter text-base text-charcoal/70 leading-relaxed">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesList;
